// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-header-custom .header-content mat-icon {
  font-size: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  width: auto;
}

.header-content .header-text .subtitle {
  font-size: 0.8rem;
}

.list_container {
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

ul {
  list-style-type: none;
  padding: 0.5rem 0.5rem 0 0.5rem;
  margin: 0;
  overflow: auto;
}

li {
  border-radius: 4px;
  margin-bottom: 1rem;
  background-color: #f5f5f5;
}

li img {
  float: left;
  margin: 0 15px 0 0;
  width: 50px;
  height: 50px;
}

.title_p {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  font-size: 1.8rem;
  background-color: rgba(221, 223, 236, 0.7411764706);
}

.address_p {
  font-size: 1rem;
}

.address_p .floor_span {
  opacity: 0.85;
  font-size: 0.8em;
  display: block;
  line-height: 1;
}

li p {
  margin-bottom: 0.5rem;
}

.info_heading_p {
  margin: 0.3rem 0;
  padding-bottom: 0.3rem;
  font-size: 1rem;
  border-bottom: 1px solid #ccc;
}

.name_p {
  margin-bottom: 0.3rem !important;
  font-size: 1.1rem;
  font-weight: 600;
}

.contact_p span:first-child {
  font-size: 1.05rem;
}

.description_p {
  font-size: 1rem;
  line-height: 1.5;
  text-align: justify;
}

.caretaker-div {
  background-color: #f1f1f1;
}

.flex-grow-container {
  display: flex;
  flex-grow: 1;
  align-items: center;
  margin-bottom: 0.5rem;
}

.no_results_container {
  font-weight: 600;
  font-size: 1.3rem;
  padding: 1rem;
  text-align: center;
}

.legend_container {
  border-top: 1px solid #ccc;
  padding: 0.5rem;
  display: inline-flex;
  justify-content: space-between;
}

.legend_element {
  font-size: 0.85rem;
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 5px;
}

.legend_element .color {
  display: inline-block;
  height: 16px;
  width: 16px;
  border-radius: 3px;
  margin-right: 5px;
}

.legend_element .text {
  line-height: 16px;
  font-weight: 600;
}

.badge {
  font-size: 0.9rem;
  background-color: #eee;
  color: #111;
  font-weight: 600;
}

.status-accepted {
  border: 2px solid #19d21f;
  /* Material Design Green */
  border-radius: 4px;
}

.status-rejected {
  border: 2px solid #f44336;
  /* Material Design Red */
  border-radius: 4px;
}

.status-pending {
  border: 2px solid #000000;
  /* Material Design Gray */
  border-radius: 4px;
}

.excel-btn.mat-raised-button.mat-accent {
  background-color: #217346;
  color: #fff;
}

.excel-btn.mat-raised-button.mat-accent:hover {
  background-color: #1d5e3a;
  /* a bit darker on hover */
}

.map {
  transition: all 350ms ease-in-out;
}

.map-expanded {
  width: 100% !important;
}

.png-btn {
  scale: 1;
  transition: all 0.15s ease-in-out;
}

.png-btn:active {
  scale: 0.95;
  transition: all 0.05s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/dashboard/overview/overview.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAMA;EAEE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAJF;;AASA;EACE,qBAAA;EACA,+BAAA;EACA,SAAA;EACA,cAAA;AANF;;AASA;EAEE,kBAAA;EAEA,mBAAA;EACA,yBAAA;AARF;;AAWA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AARF;;AAWA;EAGE,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,6BAAA;EAIA,iBAAA;EACA,mDAAA;AAdF;;AAiBA;EACE,eAAA;AAdF;;AAiBA;EACE,aAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAdF;;AAiBA;EAEE,qBAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,sBAAA;EAEA,eAAA;EACA,6BAAA;AAhBF;;AAmBA;EACE,gCAAA;EACA,iBAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,kBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,yBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;AAhBF;;AAmBA;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,0BAAA;EACA,eAAA;EACA,oBAAA;EACA,8BAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AAhBF;;AAmBA;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAhBF;;AAmBA;EAEE,iBAAA;EAEA,gBAAA;AAlBF;;AA0BA;EACE,iBAAA;EAGA,sBAAA;EACA,WAAA;EACA,gBAAA;AAzBF;;AA+BA;EACE,yBAAA;EACA,0BAAA;EACA,kBAAA;AA5BF;;AA+BA;EACE,yBAAA;EACA,wBAAA;EACA,kBAAA;AA5BF;;AA+BA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;AA5BF;;AA8BA;EACE,yBAAA;EACA,WAAA;AA3BF;;AA8BA;EACE,yBAAA;EACA,0BAAA;AA3BF;;AA8BA;EACE,iCAAA;AA3BF;;AA8BA;EACE,sBAAA;AA3BF;;AA8BA;EACE,QAAA;EACA,iCAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,iCAAA;AA3BF","sourcesContent":[".card-header-custom .header-content mat-icon {\r\n  font-size: 35px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: auto;\r\n  width: auto;\r\n}\r\n\r\n.header-content .header-text .subtitle {\r\n  font-size: 0.8rem;\r\n}\r\n\r\n//\r\n//\r\n//users found list\r\n\r\n.list_container {\r\n  // background-color: rgba(0, 0, 0, 0.08);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  // background-color: #fbf9ec;\r\n  // border: 1px solid #dcdcdc\r\n}\r\n\r\nul {\r\n  list-style-type: none;\r\n  padding: 0.5rem 0.5rem 0 0.5rem;\r\n  margin: 0;\r\n  overflow: auto;\r\n}\r\n\r\nli {\r\n  // padding: 10px 10px 0 10px;\r\n  border-radius: 4px;\r\n  // overflow: auto;\r\n  margin-bottom: 1rem;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\nli img {\r\n  float: left;\r\n  margin: 0 15px 0 0;\r\n  width: 50px;\r\n  height: 50px;\r\n}\r\n\r\n.title_p {\r\n  // font: bold 18px/1.5 Helvetica, Verdana, sans-serif;\r\n  // min-height: 45px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  // background-color: #fff;\r\n  border-bottom: 1px solid #eee;\r\n  // margin: -10px -10px 0 -10px;\r\n  // padding: 5px 0;\r\n  // padding: 0 .5rem;\r\n  font-size: 1.8rem;\r\n  background-color: #dddfecbd;\r\n}\r\n\r\n.address_p {\r\n  font-size: 1rem;\r\n}\r\n\r\n.address_p .floor_span {\r\n  opacity: 0.85;\r\n  font-size: 0.8em;\r\n  display: block;\r\n  line-height: 1;\r\n}\r\n\r\nli p {\r\n  // font-size: 14px/1.5;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.info_heading_p {\r\n  margin: 0.3rem 0;\r\n  padding-bottom: 0.3rem;\r\n  // margin-bottom: 0.5rem;\r\n  font-size: 1rem;\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n\r\n.name_p {\r\n  margin-bottom: 0.3rem !important;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.contact_p span:first-child {\r\n  font-size: 1.05rem;\r\n}\r\n\r\n.description_p {\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n  text-align: justify;\r\n}\r\n\r\n.caretaker-div {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n.flex-grow-container {\r\n  display: flex;\r\n  flex-grow: 1;\r\n  align-items: center;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.no_results_container {\r\n  font-weight: 600;\r\n  font-size: 1.3rem;\r\n  padding: 1rem;\r\n  text-align: center;\r\n}\r\n\r\n.legend_container {\r\n  border-top: 1px solid #ccc;\r\n  padding: 0.5rem;\r\n  display: inline-flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.legend_element {\r\n  font-size: 0.85rem;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  margin: 0 5px;\r\n}\r\n\r\n.legend_element .color {\r\n  display: inline-block;\r\n  height: 16px;\r\n  width: 16px;\r\n  border-radius: 3px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.legend_element .text {\r\n  // display: flex;\r\n  line-height: 16px;\r\n  // flex-grow: 1;\r\n  font-weight: 600;\r\n}\r\n\r\n// li:hover {\r\n// background: rgba(0, 0, 0, 0.02);\r\n// cursor: pointer;\r\n// }\r\n\r\n.badge {\r\n  font-size: 0.9rem;\r\n  // background-color: #3f51b5;\r\n  // color: #fff;\r\n  background-color: #eee;\r\n  color: #111;\r\n  font-weight: 600;\r\n}\r\n\r\n//users found list\r\n//\r\n//\r\n.status-accepted {\r\n  border: 2px solid #19d21f;\r\n  /* Material Design Green */\r\n  border-radius: 4px;\r\n}\r\n\r\n.status-rejected {\r\n  border: 2px solid #f44336;\r\n  /* Material Design Red */\r\n  border-radius: 4px;\r\n}\r\n\r\n.status-pending {\r\n  border: 2px solid #000000;\r\n  /* Material Design Gray */\r\n  border-radius: 4px;\r\n}\r\n.excel-btn.mat-raised-button.mat-accent {\r\n  background-color: #217346;\r\n  color: #fff;\r\n}\r\n\r\n.excel-btn.mat-raised-button.mat-accent:hover {\r\n  background-color: #1d5e3a;\r\n  /* a bit darker on hover */\r\n}\r\n\r\n.map {\r\n  transition: all 350ms ease-in-out;\r\n}\r\n\r\n.map-expanded {\r\n  width: 100% !important;\r\n}\r\n\r\n.png-btn {\r\n  scale: 1;\r\n  transition: all 0.15s ease-in-out;\r\n}\r\n\r\n.png-btn:active {\r\n  scale: 0.95;\r\n  transition: all 0.05s ease-in-out;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
